import { styled } from '../../../theme';
import { Paragraph } from '../../Paragraph';

export const Text = styled(Paragraph)`
	text-align: center;
`;
